import SMSProviderCECPage from './SMSProviderCECPage';

export default SMSProviderCECPage;
